/**
 * FieldToken — reusable token pill for template fields.
 *
 * Variants:
 *   - field token (blue) with remove button
 *   - custom token (amber) with inline text input + remove button
 *   - preview token (read-only, for table cells)
 */

const FieldToken = ({ label, isCustom, customValue, onCustomChange, onRemove, preview }) => {
  if (preview) {
    return (
      <span className={`ct-token ct-token--preview ${isCustom ? 'ct-token--custom' : ''}`}>
        {isCustom ? customValue || 'Custom' : label}
      </span>
    );
  }

  return (
    <span className={`ct-token ${isCustom ? 'ct-token--custom' : 'ct-token--field'}`}>
      {isCustom ? (
        <input
          type="text"
          className="ct-token__input"
          placeholder="Enter text..."
          value={customValue || ''}
          onChange={(e) => onCustomChange?.(e.target.value)}
          onClick={(e) => e.stopPropagation()}
        />
      ) : (
        <span className="ct-token__label">{label}</span>
      )}
      {onRemove ? (
        <button type="button" className="ct-token__remove" onClick={onRemove} aria-label={`Remove ${label}`}>
          &times;
        </button>
      ) : null}
    </span>
  );
};

export default FieldToken;
